import React, { useCallback } from 'react';
import { useGiftWrapContext } from './context/GiftWrapContext.jsx';
import { UserInputProvider, useUserInput } from './context/UserInputContext.tsx';
import { GiftWrapModal } from './components/GiftWrapModal/index';
import { AskModal } from './components/GiftWrapModal/ask-modal.jsx';
import { PageProvider, usePage } from './context/PageContext.jsx';

/**
 * Inner component that has access to all contexts.
 * @returns {import('react').ReactElement}
 */
function GiftWrapModals() {
  const { giftWrapModalOpen, setGiftWrapModalOpen, askModalOpen, setAskModalOpen, resetGiftWrapState } =
    useGiftWrapContext();
  const userInput = useUserInput();
  const { resetPageContext } = usePage();

  const handleCloseGiftWrapModal = useCallback(() => {
    // Reset all contexts when modal closes.
    resetGiftWrapState();
    userInput.clearAll();
    resetPageContext();
    setGiftWrapModalOpen(false);
  }, [setGiftWrapModalOpen, resetGiftWrapState, userInput, resetPageContext]);

  const handleClose = useCallback(() => {
    setAskModalOpen(false);
  }, [setAskModalOpen]);

  return (
    <>
      <AskModal isOpen={askModalOpen} onClose={handleClose} />
      <GiftWrapModal isOpen={giftWrapModalOpen} onClose={handleCloseGiftWrapModal} />
    </>
  );
}

/**
 * Main App component with providers.
 * @returns {(import('react').ReactElement | null)}
 */
function App() {
  return (
    <>
      <UserInputProvider>
        <PageProvider>
          <GiftWrapModals />
        </PageProvider>
      </UserInputProvider>
    </>
  );
}

export default App;
